import { render } from "./IconFilter.vue?vue&type=template&id=4b5bfde1"
import script from "./IconFilter.vue?vue&type=script&lang=js"
export * from "./IconFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__